export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGklEQVQ4jWNUTV70n4EMwESOplGNoxqHkkYA5B0CRW+Yo5gAAAAASUVORK5CYII="